module.exports = __webpack_public_path__ + "static/10-af574244ccf0458547c4ef6923e50e49.jpeg";